const SEO = [
	{
		page: "home",
		description:
			"Murilo Machado — Senior MLOps, Platform Engineer and DevSecOps with 15+ years of experience building secure AI infrastructure, GPU clusters, and synthetic data pipelines.",
		keywords: [
			"Murilo Machado",
			"MLOps",
			"Platform Engineer",
			"DevSecOps",
			"AI Infrastructure",
			"GPU Cluster",
			"DGX",
			"vLLM",
			"Open WebUI",
		],
	},

	{
		page: "articles",
		description:
			"Articles by Murilo Machado on MLOps, AI infrastructure, DevSecOps, Platform Engineering, and synthetic data generation.",
		keywords: [
			"Murilo Machado",
			"MLOps",
			"AI",
			"DevSecOps",
			"Platform Engineering",
			"Articles",
		],
	},

	{
		page: "projects",
		description:
			"Projects by Murilo Machado — business ventures, open-source tools including aigate (AI security sandbox), SpecHammer (Kubernetes testing), yankrun, structlint, and more.",
		keywords: [
			"Murilo Machado",
			"Open Source",
			"Go",
			"Kubernetes",
			"aigate",
			"SpecHammer",
			"DevSecOps",
			"MLOps",
		],
	},

	{
		page: "contact",
		description:
			"Get in touch with Murilo Machado — open to consulting, collaboration, and new opportunities in MLOps, Platform Engineering, and DevSecOps.",
		keywords: [
			"Murilo Machado",
			"Contact",
			"MLOps",
			"Platform Engineering",
			"Consulting",
		],
	},
];

export default SEO;
